import moment from 'moment';

export default function genererCritereRechercheEcheancePaiementFacture() {
  return {
    datesMouvement: {
      dateDebut: (moment().startOf('month')).toDate(),
      dateFin: (moment().endOf('month')).toDate(),
    },
    modesReglementsIds: [],
    payeurIds: [],
    factureCodes: [],
    agencesIds: [],
    commercialIds: [],
    assistantIds: [],
    paye: false,
    natures: [],
  };
}
